<template>
	<div class="hairlist">
		<div class="td">发型师管理</div>
		<div class="nav-bar">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane label="发型师管理" name="first">
					<list-manage></list-manage>
				</el-tab-pane>
				<el-tab-pane label="考核管理" name="second" :lazy="true">
					<list-attendance></list-attendance>
				</el-tab-pane>
				<el-tab-pane label="指标管理" name="third">
					<index-manage></index-manage>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import listManage from './childlist/listManage'
	import listAttendance from './childlist/listAttendance'
	import indexManage from './childlist/indexManage'
	export default {
		components: {
			listManage,
			listAttendance,
			indexManage,
		},
		data() {
			return {
				activeName: "first",
			};
		},
		methods: {
			handleClick(tab, event) {
				// console.log(tab, event);
			},
		},
	}
</script>

<style>
	.hairlist .td {
		margin-bottom: 40px;
	}
</style>